import { closePageModals, setModalPathname } from "@/stores/modal";
import { useEffect, useLayoutEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * 페이지를 떠나면 그 페이지가 띄운 모달도 거둔다. ModalStack 은 라우트 바깥 앱 루트에서
 * 렌더되므로, 뒤로 가기로 화면이 바뀌어도 모달·dim 이 그대로 남아 옮겨 간 화면이 클릭되지
 * 않는다. App 루트에서 한 번만 호출한다.
 *
 * pathname 기록은 layout effect, 정리는 passive effect — 이 순서가 계약이다. 한 커밋에서
 * 모든 layout effect 는 모든 passive effect 보다 먼저 끝나므로, 새 화면이 진입하며
 * `useEffect` 에서 띄우는 모달(버전 포워드 "변경 사항 확인")은 항상 새 pathname 을 보고
 * 찍힌다. 둘 다 passive 로 두면 이펙트가 자식 → 부모 순이라 그 모달이 직전 pathname 으로
 * 찍혀 곧바로 지워진다.
 *
 * 렌더 중에 기록하면 안 된다 — react-router v7 은 navigate 를 `startTransition` 으로
 * 감싸므로 새 pathname 렌더는 버려질 수 있고, 그동안 화면에 남아 있는 **이전 화면**의
 * push 가 새 pathname 으로 찍혀 이탈 정리를 빠져나간다.
 *
 * search 변화는 같은 화면의 상태 변경이므로(편집기의 워크북 쿼리 등) pathname 만 본다.
 */
export function usePageModalCleanup() {
  const { pathname } = useLocation();

  useLayoutEffect(() => {
    setModalPathname(pathname);
  }, [pathname]);

  useEffect(() => {
    closePageModals();
  }, [pathname]);
}
